import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '@chegg-wt/core/state'
import { PageHeader, PageHeaderWrapper } from '@chegg-wt/core/components/Layouts/styled'
import { projectNameSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { updateMessagingFlagSelector } from '@chegg-wt/core/state/app/selectors'
import { font } from '@chegg-ui/theme'
import { Config } from '@chegg-wt/core/config'
import { CM } from '@chegg-wt/core/constants/site'
import { SubHeadingBCRest } from '../../BrandConsolidation'

interface Props {
  projectName: string
  updateMessagingFeatureEnabled: boolean
  className?: string
}

export const ViewPageTop: React.FunctionComponent<Props> = ({
  projectName,
  updateMessagingFeatureEnabled,
  className,
}) => {
  const { appName } = Config
  return (
    <PageHeaderWrapper className={className}>
      <PageHeader fontSizeOverride={font.size.px36} title={projectName}>
        {projectName}
      </PageHeader>
      {projectName && (appName !== CM || updateMessagingFeatureEnabled) && (
        <SubHeadingBCRest fontSizeOverride={font.size.px36} />
      )}
    </PageHeaderWrapper>
  )
}

const mapStateToProps = (state: AppState) => ({
  projectName: projectNameSelector(state),
  updateMessagingFeatureEnabled: updateMessagingFlagSelector(state),
})

export default connect(mapStateToProps)(ViewPageTop)
